function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
    if (document.body.classList.contains("product")) {
      var sectionId = this.closest(".product__info-container")
        .getAttribute("id")
        .replace("ProductInfo-", "");
      var price__regular = document.querySelector(
        `#price-${sectionId} #price__regular`,
      );
      var atc__prices = document.querySelectorAll(`[atc__price]`);
      var price_sticky_atc = document.getElementById("price_sticky_regular");

      var new__price =
        Number(this.input.value) *
        Number(price__regular.getAttribute("data-price"));

      atc__prices.forEach((atc__price) => {
        if (price__regular.innerHTML.includes("€")) {
          atc__price.innerHTML = (new__price / 100).toFixed(2) + " €";
        } else if (price__regular.innerHTML.includes("£")) {
          atc__price.innerHTML = "£" + (new__price / 100).toFixed(2);
        } else {
          atc__price.innerHTML = "$" + (new__price / 100).toFixed(2);
        }
      });

      if (price__regular.innerHTML.includes("€")) {
        price_sticky_atc.innerHTML = (new__price / 100).toFixed(2) + " €";
      } else if (price__regular.innerHTML.includes("£")) {
        price_sticky_atc.innerHTML = "£" + (new__price / 100).toFixed(2);
      } else {
        price_sticky_atc.innerHTML = "$" + (new__price / 100).toFixed(2);
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

/*
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
  }
}

customElements.define("header-drawer", HeaderDrawer);
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this),
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    if (this.parentElement.classList.contains("qv-product-images")) {
      this.slidesPerPage = 1;
    } else {
      this.slidesPerPage = Math.floor(
        this.slider.clientWidth / this.sliderItems[0].clientWidth,
      );
    }
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (document.querySelector(".container_images_thumbnails")) {
      document.querySelector(".container_images_thumbnails").style.display =
        "block";
    }
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideWidth = this.slider.clientWidth;
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + slideWidth
        : this.slider.scrollLeft - slideWidth;
    if (this.slider.classList.contains("product__media-list")) {
      const eventSlideChange = new CustomEvent("productSlideChange", {
        detail: {
          slider: this.slider,
          eventSlider: event.currentTarget.name,
        },
      });
      window.dispatchEvent(eventSlideChange);
    } else {
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updatePreOrderDate();
    this.updateVariantDescription();
    this.updateTitle();
    this.secondDescription();
    this.updateUSP();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    var updateVariantEvent = new CustomEvent("updateVariant", {
      detail: {
        id: this.currentVariant.id,
        compare_at_price: this.currentVariant.compare_at_price || 0,
        price: this.currentVariant.price || 0,
      },
    });

    document.dispatchEvent(updateVariantEvent);

    if (
      document
        .querySelector(`[data-labels-for-variant="${this.currentVariant.id}"]`)
        ?.getAttribute("data-labels-for-preorder").length > 0 &&
      document
        .querySelector(`[data-labels-for-variant="${this.currentVariant.id}"]`)
        ?.getAttribute("data-labels-for-preorder-is-preorder") === "true"
    ) {
      document.getElementById("addtocart").removeAttribute("disabled");
      document.querySelectorAll(".main_atc_unavailable").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelectorAll(".main_atc_available").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelectorAll(".main_atc_preorder").forEach((atcLabel) => {
        atcLabel.classList.remove("hide_span");
      });

      document.querySelector(".item-add_to_cart").classList.add("min-text");
    } else if (
      document
        .querySelector(`[data-labels-for-variant="${this.currentVariant.id}"]`)
        ?.getAttribute("data-variant-available") === "true"
    ) {
      document.getElementById("addtocart").removeAttribute("disabled");
      document.querySelectorAll(".main_atc_available").forEach((atcLabel) => {
        atcLabel.classList.remove("hide_span");
      });
      document.querySelectorAll(".main_atc_unavailable").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelectorAll(".main_atc_preorder").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelector(".item-add_to_cart").classList.remove("min-text");
    } else {
      document.getElementById("addtocart").setAttribute("disabled", true);
      document.querySelectorAll(".main_atc_unavailable").forEach((atcLabel) => {
        atcLabel.classList.remove("hide_span");
      });
      document.querySelectorAll(".main_atc_available").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelectorAll(".main_atc_preorder").forEach((atcLabel) => {
        atcLabel.classList.add("hide_span");
      });
      document.querySelector(".item-add_to_cart").classList.remove("min-text");
    }
  }

  updateVariantDescription() {
    if (document.querySelector(".product-variant-description")) {
      var currentVariant = document.querySelector(
        `.product-variant-description .item-description-variant[data-variant-id="${this.currentVariant.id}"]`,
      );
      var inline_descriptions = document.querySelectorAll(
        ".product-variant-description .item-description-variant",
      );
      inline_descriptions.forEach((inline) => {
        inline.classList.add("hidden");
      });
      currentVariant.classList.remove("hidden");
    }
  }

  updateTitle() {
    const productTitleElements = document.querySelectorAll("[product-title]");

    if (productTitleElements.length === 0) return;

    productTitleElements.forEach((productTitleElement) => {
      const productTitleList = Array.from(
        productTitleElement.querySelectorAll(".item-title-variant"),
      );

      if (productTitleList.length === 0) return;

      const currentProductTitle = productTitleList.find((item) => {
        return (
          item.getAttribute("data-variant-id") ===
          this.currentVariant.id.toString()
        );
      });

      productTitleList.forEach((item) => {
        item.classList.add("hidden");
      });

      if (currentProductTitle) {
        currentProductTitle.classList.remove("hidden");
      }
    });
  }

  secondDescription() {
    if (document.querySelector("[product-second-description]")) {
      const productSecondDescription = document.querySelector(
        "[product-second-description]",
      );
      const productSecondDescriptionList = Array.from(
        productSecondDescription.querySelectorAll(".item-second-description"),
      );

      if (productSecondDescriptionList.length == 0) return;
      const currentProductSecondDescription = productSecondDescriptionList.find(
        (item) => {
          return (
            item.getAttribute("data-variant-id") ==
            this.currentVariant.id.toString()
          );
        },
      );

      if (currentProductSecondDescription) {
        productSecondDescriptionList.forEach((item) => {
          item.classList.add("hidden");
        });
        currentProductSecondDescription.classList.remove("hidden");
      }
    }
  }

  updateUSP() {
    if (document.querySelector("[product-usp]")) {
      const productUSP = document.querySelector("[product-usp]");
      const productUSPList = Array.from(
        productUSP.querySelectorAll(".item-usp"),
      );

      if (productUSP.length == 0) return;

      const currentProductUSP = productUSPList.find((item) => {
        return (
          item.getAttribute("data-variant-id") ==
          this.currentVariant.id.toString()
        );
      });

      if (currentProductUSP) {
        productUSPList.forEach((item) => {
          item.classList.add("hidden");
        });
        currentProductUSP.classList.remove("hidden");
      }
    }
  }

  updatePreOrderDate() {
    var labelPreOrderDate = document.querySelector(".pre_order-info");
    var mainProperties = document.getElementById("variant_properties");
    var currentVariant = document.querySelector(
      `[data-labels-for-variant="${this.currentVariant.id}"]`,
    );
    if (
      currentVariant?.getAttribute("data-labels-for-preorder").length > 0 &&
      document
        .querySelector(`[data-labels-for-variant="${this.currentVariant.id}"]`)
        ?.getAttribute("data-labels-for-preorder-is-preorder") === "true"
    ) {
      labelPreOrderDate.style.display = "block";
    } else {
      labelPreOrderDate.style.display = "none";
    }
    mainProperties.value = currentVariant?.getAttribute(
      "data-labels-for-preorder",
    );
    labelPreOrderDate.querySelector(".pre_order-info-label").innerHTML =
      window.variantStrings.preOrder +
      " : " +
      currentVariant?.getAttribute("data-labels-for-preorder-date-format");
    labelPreOrderDate
      .querySelector(".pre_order-info-label")
      .setAttribute(
        "date-value",
        currentVariant?.getAttribute("data-labels-for-preorder"),
      );
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    document.querySelector(".container_images_thumbnails").style.display =
      "block";
    const imageAltContainers = document.querySelectorAll(
      ".img__Alts_thumbnail",
    );
    const imageSliderContainers = document.querySelectorAll(
      ".product__media-list .slider__slide",
    );

    const currentVarForCompare = this.currentVariant.id;

    let firstEntry = true;
    let firstThumbnail;

    imageAltContainers.forEach((container) => {
      container.classList.remove("coop_hide_thumbnail");
      const compareAltsVars = container.getAttribute("data-thumb-variant");

      if (compareAltsVars === currentVarForCompare.toString()) {
        container.style.order = container.getAttribute("data-thumb-order");
        if (firstEntry) {
          firstThumbnail = container.querySelector("img");
          firstEntry = false;
        }
      } else {
        container.classList.add("coop_hide_thumbnail");
      }
    });

    imageSliderContainers.forEach((slide) => {
      slide.classList.remove("coop_hide_slide");
      const compareAltsVars = slide.getAttribute("media-variant");

      if (compareAltsVars !== currentVarForCompare.toString()) {
        slide.classList.add("coop_hide_slide");
      }
    });

    if (firstThumbnail) {
      firstThumbnail.click();
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );

    const prodPlus = document.getElementsByClassName("product_addons_add");
    const accIds = document.getElementsByClassName("added_products_acc");
    const svgPlus = document.getElementsByClassName("product_addons_pluss");
    const svgCheck = document.getElementsByClassName("product_addons_check");
    const camera_div = document.querySelector(".product_camera_div");
    const tray_div = document.querySelector(".product_trays_div");

    camera_div.style.display = "none";
    tray_div.style.display = "none";
    for (let i = 0; i < prodPlus.length; i++) {
      accIds[i].setAttribute("data-disable", "0");
      prodPlus[i].classList.remove("chosen");
      svgPlus[i].style.display = "block";
      svgCheck[i].style.display = "none";
    }

    const allAddOns = document.querySelectorAll("[product-addon-item]");
    for (let i = 0; i < allAddOns.length; i++) {
      if (allAddOns[i].getAttribute("data-variant") != this.currentVariant.id) {
        allAddOns[i].style.display = "none";
      } else {
        allAddOns[i].style.display = "block";
      }
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  //           document.getElementById("price_sticky_regular").innerHTML = document.getElementById("price__regular").getAttribute("data-value");
  //         document.getElementById("price_sticky_regular").setAttribute("data-price", document.getElementById("price__regular").getAttribute("data-price"));
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const price_item = document.querySelectorAll(".price_atc");
        const price_item_sticky = document.querySelectorAll(
          ".price_sticky_regular",
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          price_item.forEach((price) => {
            price.innerHTML = document
              .querySelector(`#${id} #price__regular`)
              .getAttribute("data-value");
            price.setAttribute(
              "data-price",
              document
                .querySelector(`#${id} #price__regular`)
                .getAttribute("data-price"),
            );
          });
          /*
     document.getElementById("price_atc").innerHTML = document.querySelector(`#${id} #price__regular`).getAttribute("data-value");
    
       document.getElementById("price_atc").setAttribute("data-price", document.querySelector(`#${id} #price__regular`).getAttribute("data-price"));
       */
          price_item_sticky.forEach((price) => {
            price.setAttribute(
              "data-price",
              document
                .querySelector(`#${id} #price__regular`)
                .getAttribute("data-price"),
            );
            price.innerHTML = document
              .querySelector(`#${id} #price__regular`)
              .getAttribute("data-value");
          });
          /*
            document.getElementById("price_sticky_regular").setAttribute("data-price", document.querySelector(`#${id} #price__regular`).getAttribute("data-price"));
            document.getElementById("price_sticky_regular").innerHTML = document.querySelector(`#${id} #price__regular`).getAttribute("data-value");
          */
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

/* lozad init */
const observer = lozad(".lozad", {
  rootMargin: "10px 0px", // syntax similar to that of CSS Margin
  threshold: 0.1, // ratio of element convergence
});
observer.observe();
